require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/angular/index.js
// module id = 473
// module chunks = 1